import React from 'react';

function PageNotFound() {
  return (
    <div>
      <h1>404</h1>
      <h1>PageNotFound</h1>
    </div>
  );
}

export default PageNotFound;
